import { useEffect, useState } from "react";
import api from "../api";
import { getEmployee, clearEmployeeSession } from "../auth";
import EmployeeLayout from "../components/EmployeeLayout";

const PayslipList = () => {
  const [payslips, setPayslips] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const pageSize = 5;
  const emp = getEmployee();
  const [year, setYear] = useState(new Date().getFullYear());
  const [month, setMonth] = useState(new Date().getMonth() + 1);

  const loadPayslips = async () => {
    setLoading(true);
    try {
      const res = await api.get("/employee/payslips", {
        params: { year, month },
      });
      const list = res.data || [];
      setPayslips(list);
      setPage(1);
    } catch (err) {
      console.error(err);
      alert("Error loading payslips");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPayslips();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [year, month]);

  const handleLogout = () => {
    clearEmployeeSession();
    window.location.href = "/login";
  };

  const formatMonth = (year, month) => {
    const names = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    return `${names[month - 1]} ${year}`;
  };

  const totalPages = Math.max(1, Math.ceil((payslips || []).length / pageSize));
  const visiblePayslips = (payslips || []).slice(
    (page - 1) * pageSize,
    page * pageSize
  );

  const years = [];
  const currentYear = new Date().getFullYear();
  for (let y = currentYear; y >= currentYear - 4; y--) years.push(y);
  const months = [
    { value: 1, label: "Jan" },
    { value: 2, label: "Feb" },
    { value: 3, label: "Mar" },
    { value: 4, label: "Apr" },
    { value: 5, label: "May" },
    { value: 6, label: "Jun" },
    { value: 7, label: "Jul" },
    { value: 8, label: "Aug" },
    { value: 9, label: "Sep" },
    { value: 10, label: "Oct" },
    { value: 11, label: "Nov" },
    { value: 12, label: "Dec" },
  ];

  return (
    <EmployeeLayout>
      <header className="emp-header">
        <div>
          <h2 className="emp-title">My Payslips</h2>
          {emp && (
            <p className="emp-subtitle">
              {emp.name} • {emp.username}
            </p>
          )}
        </div>
        {/* <button className="btn-secondary" onClick={handleLogout}>
          Logout
        </button> */}
      </header>

      <div className="payslip-filters">
            <div className="payslip-filter-block">
              <span className="payslip-filter-label">Month</span>
              <select
                className="payslip-select"
                value={month}
                onChange={(e) => setMonth(Number(e.target.value))}
              >
                {months.map((m) => (
                  <option key={m.value} value={m.value}>
                    {m.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="payslip-filter-block">
              <span className="payslip-filter-label">Year</span>
              <select
                className="payslip-select"
                value={year}
                onChange={(e) => setYear(Number(e.target.value))}
              >
                {years.map((y) => (
                  <option key={y} value={y}>
                    {y}
                  </option>
                ))}
              </select>
            </div>
          </div>

      {loading ? (
        <p>Loading…</p>
      ) : payslips.length === 0 ? (
        <p>No payslips available yet.</p>
      ) : (
        <>
          <table className="table">
            <thead>
              <tr>
                <th>Period</th>
                <th>Net Pay</th>
                <th>PDF</th>
              </tr>
            </thead>
            <tbody>
              {visiblePayslips.map((p) => (
                <tr key={p.id}>
                  <td>{formatMonth(p.pay_year, p.pay_month)}</td>
                  <td>₹{Number(p.net_pay).toLocaleString("en-IN")}</td>
                  <td>
                    <a
                      href={`/api/employee/payslips/${p.id}/download?token=${localStorage.getItem("emp_token")}`}
                      target="_blank"
                      rel="noreferrer"
                      className="btn-chip"
                    >
                      Download
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="pagination">
            <button
              className="btn-small"
              onClick={() => setPage((p) => Math.max(1, p - 1))}
              disabled={page === 1}
            >
              Prev
            </button>
            <span className="pagination-info">
              Page {page} of {totalPages}
            </span>
            <button
              className="btn-small"
              onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
              disabled={page === totalPages}
            >
              Next
            </button>
          </div>
        </>
      )}
    </EmployeeLayout>

  );
};

export default PayslipList;
